export const formatNumberToReadable = (num: number) => {
    if (num < 1000) return num.toString(); // If the number is less than 1000, just return it
    const k = 1000;
    const dm = 1; // Decimal places
    const sizes = ['k', 'M', 'B', 'T']; // Different scales
    const i = Math.floor(Math.log(num) / Math.log(k)); // Get the index for the correct scale
    return (num / Math.pow(k, i)).toFixed(dm) + sizes[i - 1]; // Convert and format
};
